//! вывод годов в фильтр от 2025 и далее по факту наступления след года
export const years = generateYears(2025, new Date().getFullYear());

function generateYears(fromYear: number, toYear: number) {
  const years = [];
  for (let year = fromYear; year <= toYear; year++) {
    years.push({ ID: year - fromYear + 1, Title: String(year) });
  }
  return years;
}

const getCurrentDate = () => {
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();

  return {
    year: {
      id: currentYear,
      name: currentYear.toString(),
    },
  };
};

const currentDate = getCurrentDate();

export const initialFilterReportRegion = {
  year: {
    selected: [currentDate.year.name],
    selectedIds: [currentDate.year.id],
    search: '',
  },
  group: { selected: ['BOP'], selectedIds: [1], search: '' },
  department: { selected: [], selectedIds: [], search: '' },
};

export const filtersOpenReportRegion = {
  year: false,

  group: false,
  department: false,
};

export const filterConfigReportRegion = {
  year: {
    title: 'Год',
    hasSearch: false,
    searchPlaceholder: 'Поиск по году',
    options: years.map((item) => item.Title),
  },

  group: {
    title: 'Группа',
    hasSearch: true,
    searchPlaceholder: 'Поиск по группе',
    options: [],
  },
  department: {
    title: 'Отдел',
    hasSearch: true,
    searchPlaceholder: 'Поиск по отделу',
    options: [],
  },
};


export const monthsRegion = ['Янв', 'Фев', 'Мар', 'Апр', 'Май', 'Июн', 'Июл', 'Авг', 'Сен', 'Окт', 'Ноя', 'Дек'];
